
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Refs | v4`}</h2>
    <p>{`Passing a `}<inlineCode parentName="p">{`ref`}</inlineCode>{` prop to a styled component will give you one of two things depending on the styled target:`}</p>
    <ul>
      <li parentName="ul">{`the underlying DOM node (if targeting a basic element, e.g. `}<inlineCode parentName="li">{`styled.div`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`a React component instance (if targeting a custom component e.g. extended from `}<inlineCode parentName="li">{`React.Component`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`const Input = styled.input\`
  padding: 0.5em;
  margin: 0.5em;
  color: palevioletred;
  background: papayawhip;
  border: none;
  border-radius: 3px;
\`;

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  render() {
    return (
      <Input
        ref={this.inputRef}
        placeholder="Hover to focus!"
        onMouseEnter={() => {
          this.inputRef.current.focus()
        }}
      />
    );
  }
}

render(
  <Form />
);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Using an older version of styled-components (below 4.0.0) or of React? Use the `}<a parentName="p" {...{
          "href": "/docs/api#innerref-prop"
        }}><inlineCode parentName="a">{`innerRef`}</inlineCode>{` prop`}</a>{` instead.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;